import { OperationStatus } from '@pressreader/appstore';
import type { ArticleCollections } from '@pressreader/social-types';

import type { State } from './article.collections';

export function updateArticleCollections(
    state: State,
    {
        articleId,
        collections,
    }: {
        articleId: string;
        collections: ArticleCollections | undefined;
    },
): typeof state {
    return {
        ...state,
        articleCollections: {
            ...state.articleCollections,
            [articleId]: {
                ...state.articleCollections[articleId],
                status: OperationStatus.Done,
                collections,
            },
        },
    };
}

export function updateArticleStatus(
    state: State,
    {
        articleId,
        status,
    }: {
        articleId: string;
        status: OperationStatus;
    },
): typeof state {
    return {
        ...state,
        articleCollections: {
            ...state.articleCollections,
            [articleId]: {
                ...state.articleCollections[articleId],
                status: status,
            },
        },
    };
}
